export const AdminDashboard = () => {
  return <div className="h-full w-full flex">Dashboard</div>;
};
